import { createSelector } from 'reselect';

export const initialisedSelector = createSelector(
  state => state.app.initialised,
  initialised => initialised
);

export const loadingSelector = createSelector(
  state => state.app.loading,
  loading => loading
);

export const labelsSelector = createSelector(
  state => state.app.data.labels,
  labels => labels
);

export const basepathSelector = createSelector(
  state => state.app.basepath,
  basepath => {
    if (basepath && basepath[basepath.length - 1] === '/') {
      basepath = basepath.substr(0, basepath.length - 1); // eslint-disable-line
    }

    return basepath;
  }
);

export const getErrorSelector = createSelector(
  state => state.app.error,
  error => error
);

export const getCountry = createSelector(
  state => state.app.filters.country,
  country => country
);

export const getDistance = createSelector(
  state => state.app.distance,
  distance => distance
);

export const getSelectedBikeTypes = createSelector(
  state => state.app.selectedBikeTypes,
  bikeType => bikeType
);

export const getDealerDistance = createSelector(
  state => state.app.dealers.distance,
  distance => distance
);

export const getDealerLanguageCode = createSelector(
  state => state.app.dealers.languageCode,
  languageCode => languageCode
);

export const getQuery = createSelector(
  state => state.app.filters.query,
  query => query
);

export const getDealers = createSelector(
  state => state.app.dealers.results,
  dealers => dealers
);

export const getDealerCount = createSelector(
  state => state.app.dealers.count,
  dealerCount => dealerCount
);

export const getListView = createSelector(
  state => state.app.listView,
  listView => listView
);

export const getPlace = createSelector(
  state => state.app.place,
  place => place
);

export const getCountries = createSelector(
  state => state.app.countries,
  countries => countries
);

export const getDistances = createSelector(
  state => state.app.dealers.distances,
  distances => distances
);

export const getBikeTypes = createSelector(
  state => state.app.bikeTypes,
  bikeTypes => bikeTypes
);

export const getDistanceUnit = createSelector(
  state => state.app.dealers.distanceUnit,
  distanceUnit => distanceUnit
);

export const getDistanceUnitCalc = createSelector(
  state => state.app.dealers.distanceUnitCalc,
  distanceUnitCalc => distanceUnitCalc
);

export const getIsRatingsApplicable = createSelector(
  state => state.app.dealers.isRatingsApplicable,
  isRatingsApplicable => isRatingsApplicable
);

export const getSkip = createSelector(
  state => state.app.dealers.skip,
  skip => skip
);

export const getLatitude = createSelector(
  state => state.app.latitude,
  latitude => latitude
);

export const getLongitude = createSelector(
  state => state.app.longitude,
  longitude => longitude
);

export const getAllDealers = createSelector(
  state => state.app.allDealers.dealerCardData,
  allDealers => allDealers
);

export const getAllDealersSkip = createSelector(
  state => state.app.allDealers.skip,
  skip => skip
);

export const getDealersLatitude = createSelector(
  state => state.app.dealers.latitude,
  state => state.app.latitude,
  (latitude, fallbackLatitude) => latitude || fallbackLatitude
);

export const getDealersLongitude = createSelector(
  state => state.app.dealers.longitude,
  state => state.app.longitude,
  (longitude, fallbackLongitude) => longitude || fallbackLongitude
);

export const getDealerIsNextDistance = createSelector(
  state => state.app.dealers.isNextDistance,
  isNextDistance => isNextDistance
);

export const getDealersLocationText = createSelector(
  state => state.app.dealers.locationText,
  locationText => locationText
);

export const getLocationError = createSelector(
  state => state.app.locationError,
  locationError => locationError
);
